export default {
    imageAIFormRules: {
        enterDescription: 'Por favor, escriba la descripción',
        invalidDescription: 'Por favor, escriba una descripción válida',
        enterNumberOfVariations: 'Por favor, selecciona el número de variantes',
        invalidNumberOfVariations: 'You can generate maximum 4 and minimum 1 variation',
        enterStyle: 'Please select at least one style',
    },
};
